import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import type { AppState } from '../../App'
import type { PageType } from '../../interfaces/types'

import character from './character.svg'

const StyledCard = styled.div`
  margin-top: 48px;
  padding: 10%;
  display: flex;
  flex-direction: column;

  #container {
    display: flex;
    padding-top: 20px;
  }

  #card {
    background-color: #fff;
    padding: 2em;

    border-radius: 10px;
  }

  #message-bubble {
      background-color: #D2F825;
      padding: 20px;

      border-radius: 10px;

      font-weight: bold;

      word-break: keep-all;
  }

  .gray-box {
    padding: 1em;
    background-color: #EEEEEE;

    border-radius: 10px;

    font-weight: bold;

    text-align: center;
  }
`

const MyBenefitPage = (props: {
  setCurrentPage: (page: PageType, pathname?: string) => void,
  loadData: () => Promise<void>,
  state: AppState,
}) => {
  const [datum, setDatum] = useState(props.state.data[1] ? props.state.data[1] : [])
  useEffect(() => {
    if(!props.state.dataLoaded) {
      props.loadData().then(() => {
        const token = window.location.pathname.split('/')[2]
        setDatum(props.state.data.filter(row => row[4] === token)[0])
      })
    } else {
      const token = window.location.pathname.split('/')[2]
        setDatum(props.state.data.filter(row => row[4] === token)[0])
    }
  })
  return (
    <div>
    <StyledCard>
      <div id='card'>
        <div id='message-bubble'>
          {datum[0]}
        </div>
        <div id='container'>
          <img
            src={character}
            alt='character'
            style={{
              width: '100%'
            }}
          ></img>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginLeft: '30px'
          }}>
            <div className='gray-box'>{datum[1]}</div>
            <div className='gray-box'>{datum[2]}</div>
          </div>
        </div>
      </div>
    <button
      style={{
        marginTop: '20px',
        width: '100%',
        height: '50px',
        backgroundColor: '#D2F825',
        border: 'none',
        borderRadius: '10px',
        fontSize: '1em',
        fontWeight: 'bold',
      }}
      onClick={() => {
        props.setCurrentPage('RESULT')
      }}
    >뒤로 돌아가기</button>
    </StyledCard>
    </div>
  )
}

export default MyBenefitPage